import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { withStyles, Fab, Zoom } from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';

const useStyles = theme => ({
    saveButton: {
        display: "block",
        position: "fixed",
        top: 70,
        right: theme.spacing(3)
    },
    icon: {
        color: "#FAFAFA"
    },
    fab: {
        padding: theme.spacing(1),
        background: "#5CB85C",
        "&:hover": {
            background: "#5CB85C",
            opacity: 0.8
        }
    },
    fabAnimation: {
        animation: `$saveBtnEffect 2000ms ${theme.transitions.easing.easeIn}`,
    },
    "@keyframes saveBtnEffect": {
        to: {
            transform: "scale(1.3, 1.3)"
        }
    }
});

const SaveButton = props => {
    const { classes, visible = false, onClick } = props;

    return (
        <Zoom in={visible} timeout={{enter: 700, exit: 700}}>
            <div className={classes.saveButton} >
                <Fab
                    className={clsx(classes.fab, { [classes.fabAnimation]: visible })}
                    onClick={onClick}
                >
                    <SaveIcon className={classes.icon} />
                </Fab>
            </div>
        </Zoom>
    );
};

SaveButton.propTypes = {
    classes: PropTypes.object,
    visible: PropTypes.bool,
    onClick: PropTypes.func
};

export default withStyles(useStyles)(SaveButton);
